import * as types from './types';
import { uiActions } from 'state/modules/UI';
import * as formsActions from 'services/api/forms';
import { getErrorMessage, parsePagination } from 'utils';

// Get Forms
const fetchFormsRequest = () => ({
  type: types.FETCH_FORMS_REQUEST,
});

const fetchFormsSuccess = (payload) => ({
  type: types.FETCH_FORMS_SUCCESS,
  payload,
});

const fetchFormsFailed = () => ({
  type: types.FETCH_FORMS_FAILED,
});

export const fetchForms = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchFormsRequest());

    const response = await formsActions.fetchForms(params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchFormsSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchFormsFailed(error));
  };
};
